<!--
 * @Description: 页面说明
 * @Version: 版本号
 * @Author: chuzhangyi
 * @Date: 2024-07-19 10:47:59
 * @LastEditors: 最后一次编辑说明
 * @LastEditTime: 2024-07-31 14:47:50
 * @FilePath: \买家e:\LBB\wechat_business\src\components\appTabs\index.vue
-->
<template>
  <!-- <van-sticky> -->
  <van-tabs v-if="isShow" class="appTabs" v-model="active" :swipe-threshold="2" @click="handleClickTab">
    <template v-for="el in tabList">
      <van-tab v-if="el.name" :title="el.name" :name="el.path" :key="el.path"></van-tab>
    </template>
  </van-tabs>
  <!-- </van-sticky> -->
</template>

<script>
import { mapState } from 'vuex';
export default {

  name: 'AppTabs',// 组件名称

  //这里存放数据
  data() {
    return {
      active: ''
    };
  },

  //监听属性 类似于data概念
  computed: {
    ...mapState(['entry', 'appTabs']),
    tabList() {
      // single_chat_tools 单聊 group_chat_tools 群聊
      let list = this.appTabs || [];
      return list.filter(el => (el.type == this.entry || !el.type))
    },
    isShow() {
      let { path, query } = this.$route || {};
      // return !!this.tabList.find(el => el.path == path && query.source == 1);
      if(
        path == '/offers-billingScreenshot' || 
        path == '/offers-beanAssistOrderResult' ||
        path == '/portrait-addClue'
      ){
        return false;
      }
      if(query.hideNav == 1){
        return false;
      }
      let path1 = path.substring(1).split('-')[0]
      return ['portrait', 'offers', 'contract', 'orders'].includes(path1) && path !== '/offers-basis' && path !== '/offers-basisEdit'
    }
  },
  mounted() {
    if (this.isShow) {
      this.active = this.tabList[0].path;
      this.$router.replace({
        path: this.active,
        query: {
          source: 1
        }
      });
    }
  },
  methods: {
    handleClickTab(name){
      if(this.$route.path !== name){
        this.$router.replace({
          path: name,
          query: {
            source: 1
          }
        });
      }
    }
  }
}
</script>
<style lang="less" scoped>
.appTabs {
  z-index: 111;
  border-bottom: 1px solid #eee;
}
</style>
